module.exports = __webpack_public_path__ + "img/scbdwj_img.d23d3ffd.png";